import { getUserProfile } from "_services/api/user";

export const _getUserProfile = async args => {
	if ( !args )
		return;

	const userProfileParams = {
		follow         : true,
		isFollowing    : true,
		country        : true,
		stats          : true,
		block          : true,
		teams          : false,
		sports         : false,
		pendingRewards : false,
		access         : true,
		types          : true,
		followingGames : true,
		onboarding     : true
	};

	const response = await getUserProfile ( args, userProfileParams );

	return response;
};
